import { ToggleSwitch } from 'tradera/components/form-controls/toggle-switch/toggle-switch';
import { useTranslator } from 'tradera/lang/translate';
import { GtmService } from 'tradera/services/google-tagmanager/google-tagmanager-service';
import { useMemberServerStorageWithCookieFallback } from 'tradera/state/member-storage/hooks';
import { classNames } from 'tradera/utils/class-names';

type KeywordSearchSwitchProps = {
    className?: string;
    size?: 'medium' | 'small';
};

export const KeywordSearchSwitch = ({
    className,
    size = 'medium',
}: KeywordSearchSwitchProps) => {
    const { t } = useTranslator();

    const [checked, setChecked] = useMemberServerStorageWithCookieFallback(
        'keyword-search',
        false,
    );

    const handleOnChange = () => {
        const newValue = !checked;
        setChecked(newValue);

        GtmService.trackGA4('exact_search_toggle', {
            exact_search: newValue ? 1 : 0,
        });
    };

    return (
        <div
            className={classNames('border-bottom', className)}
            onMouseDown={(e) => e.preventDefault()}>
            <ToggleSwitch
                data-keyword-search-switch
                id="keyword-search"
                className="d-flex justify-content-between align-items-center"
                checked={checked}
                onChange={handleOnChange}
                label={t('search_switchKeywordSearch_label')}
                size={size}
            />
        </div>
    );
};
